import { useTranscription } from './useTranscription';
import { useTranscriptionFlag } from './useTranscriptionFlag';

import { AudioPlayer } from './AudioPlayer';
import { TranscriptionText } from './TranscriptionText';
import { TranscriptionButton } from './TranscriptionButton';
import { Attachment } from './types';
export interface AudioBallonProps {
  messageProps: {
    urlBase64: string;
    errorMessage: string;
    messageId: string;
    mimeType: string;
    authorMessage: string;
    time: string;
    direction: string;
    cuid: string;
  };
  isLoading: boolean;
  urlMedia: string;
  reply_message: string;
  attachments: Attachment[];
}

export function AudioBallon(props: Readonly<AudioBallonProps>) {
  const {
    messageProps: { direction, cuid },
    urlMedia,
    attachments,
  } = props;

  const { isLoading, error, canTryAgain, handleTranscription, getText } =
    useTranscription({
      audioUrl: urlMedia,
      messageUuid: cuid,
      currentTranscription: attachments?.length
        ? attachments[0]?.data?.transcription?.transcription ?? ''
        : '',
    });

  const { canShowTranscription, canUseTranscription } = useTranscriptionFlag();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: direction === 'received' ? 'row' : 'row-reverse',
        maxWidth: '100%',
        width: 'fit-content',
        margin: direction === 'received' ? '0 0 0 8px' : '0 8px 0 0',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '0.25rem',
          maxWidth: 'calc(100% - 40px)', // Subtraindo o espaço do botão de transcrição
          minWidth: '200px',
        }}
      >
        <AudioPlayer {...props} />
        {canShowTranscription && <TranscriptionText text={getText()} />}
      </div>
      {canShowTranscription && (
        <TranscriptionButton
          isLoading={isLoading}
          error={error}
          canTryAgain={canTryAgain}
          handleTranscription={handleTranscription}
          isEnabled={canUseTranscription}
        />
      )}
    </div>
  );
}
